import { render, staticRenderFns } from "./ExternalShare.vue?vue&type=template&id=7faa5754&scoped=true&"
import script from "./ExternalShare.vue?vue&type=script&lang=ts&"
export * from "./ExternalShare.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalShare.vue?vue&type=style&index=0&id=7faa5754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa5754",
  null
  
)

export default component.exports